import { useEffect, useState } from 'react';
import { IOption } from '@vtbhome/juicyfront/types';
import { useMemo } from 'react';
import { useProductOptionsParams } from './types';
import { debounce } from '@vtbhome/juicyfront/utils/helpers';
import { SELECT_INFINITY_PAGINATION_ITEMS_ON_PAGE } from '@shared/ui/select/constants';

export const useProductSelect = ({
    productsData,
    isLoading,
    isFetching,
    setProductsListParameters,
}: useProductOptionsParams) => {
    const [isShowEmptyLoader, setIsShowEmptyLoader] = useState(isLoading);

    const emptyOptions = useMemo(() => {
        /* Нужен пустой массив без потери ссылки после рендера */
        return [] as IOption[];
    }, []);

    const options: IOption[] = useMemo(() => {
        return (
            productsData?.items?.map((product) => {
                return {
                    label: product.name,
                    value: String(product.id),
                };
            }) || emptyOptions
        );
    }, [emptyOptions, productsData?.items]);

    const infinityScrollProductsProps = useMemo(() => {
        return {
            dataLength: productsData?.items.length || 0,
            hasMore: (productsData?.items.length || 0) < (productsData?.total || 0),
        };
    }, [productsData]);

    const handleSearch = useMemo(() => {
        return debounce((query: string, isPagination?: boolean | undefined) => {
            return setProductsListParameters((prev) => {
                setIsShowEmptyLoader(true);
                return {
                    ...prev,
                    skip: isPagination ? (prev.skip || 0) + SELECT_INFINITY_PAGINATION_ITEMS_ON_PAGE : null,
                    search: query,
                };
            });
        }, 300);
    }, [setProductsListParameters]);

    useEffect(() => {
        if (!isFetching) {
            setIsShowEmptyLoader(false);
        }
    }, [isFetching, isShowEmptyLoader]);

    return {
        productOptions: isShowEmptyLoader ? emptyOptions : options,
        productEmptyOption: emptyOptions,
        isShowEmptyLoaderProducts: isShowEmptyLoader,
        infinityScrollProductsProps,
        onSearchProducts: handleSearch,
    };
};
